<script setup>
import { Loc } from 'main.core';
import useCalculatorStore from '../../store/calculator.js';

const calculator = useCalculatorStore();

const submit = () => {
  if (calculator.isFresh && calculator.subscriptionUrl) {
    window.location.href = calculator.subscriptionUrl;
  }
  if (calculator.isFreshKz) {
    calculator.dialogFreshForm = true;
  }
  if (calculator.isArenda) {
    calculator.dialogArendaForm = true;
  }
  if (calculator.isEnterprise) {
    calculator.dialogEnterpriseForm = true;
  }
};
</script>

<template>
  <p class="cloud-calculator__summary-buttons">
    <button class="button" type="button" @click="submit">
      <template v-if="calculator.isFresh">
        {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_BUTTON_SUBMIT_SUBSCRIBE') }}
      </template>
      <template v-else>
        {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_BUTTON_SUBMIT_FORM') }}
      </template>
    </button>
  </p>
</template>
